// extracted by mini-css-extract-plugin
export default {"container":"TextBlocks_container__ZSYg5"};